// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"358":"e1d72fe7","456":"58245ebc","692":"3740b77e","740":"256eaf2d"}[chunkId] + ".chunk.js";
};